import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { format, parseISO } from 'date-fns';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField } from '@mui/material';
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { FiAlertTriangle } from "react-icons/fi";

export default function NearBy() {

    const lottiee = require('../images/lottiee.json');
    const loading = require('../images/loading.json');
    
    const [show, setShow] = useState(false);
    const [smShow, setSmShow] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const [showDescription, setShowDescription] = useState({});
    const [nearByData, setnearByData] = useState([]);
    const [updateNearBy, setupdateNearBy] = useState({});
    const [PlaceName, setPlaceName] = useState('');
    const [PlaceDesc, setPlaceDesc] = useState('');
    const [PlaceCotactNumber, setPlaceCotactNumber] = useState('');
    const [PlaceGoogleLocationLink, setPlaceGoogleLocationLink] = useState('');
    const [loader, setloader] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const filteredData = nearByData.filter((item) => {
        return (
          item.PlaceName.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });

    const handleShowMore = (index) => {
        setShowDescription({ ...showDescription, [index]: true });
    };

    const handleShowLess = (index) => {
        setShowDescription({ ...showDescription, [index]: false });
    };

    // const handleChangeUpdtNaerBY = (e) => {
    //     const { name, value, type, checked } = e.target;
    //     setupdateNearBy({
    //       ...updateNearBy,
    //       [name]: type === "checkbox" ? checked : value,
    //     });
    //   };

    const handleChangeUpdtNaerBY = (e) => {
      const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            setupdateNearBy({
                ...updateNearBy,
                [name]: checked,
            });
        } else {
            if (name === "PlaceCotactNumber") {
                const inputValue = value;
                if (/^\d{0,10}$/.test(inputValue) || inputValue === "") {
                    setupdateNearBy({
                        ...updateNearBy,
                        [name]: inputValue,
                    });
                } else {
                    alert("Enter only numbers");
                }
            } else {
                setupdateNearBy({
                    ...updateNearBy,
                    [name]: value,
                });
            }
        }
    };

      const nearByList =()=>{
        setloader(true)
        const requestOptions = {
          method: "GET",
          redirect: "follow"
        };
        
        fetch("https://api.padampura.com/NearByList", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if(result.status === true){
            //   console.log(result)
              setnearByData(result.data)
              setloader(false)
            }else{
              alert("Please Wait...!!")
            }
          })
          .catch((error) => console.error(error))
          .finally(()=> setloader(false))
      }

      const insertNearBy = ()=>{
        if (!PlaceName) {
            alert("Please enter Place Name");
            return;
        }
        const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "PlaceName": PlaceName,
                "PlaceDesc": PlaceDesc,
                // "PlaceImagePath": null,
                // "PlaceImageStream": null,
                "PlaceCotactNumber":PlaceCotactNumber,
                // "PlaceGoogleLocationLink": PlaceGoogleLocationLink
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://api.padampura.com/NearBy_Insert", requestOptions)
            .then((response) => response.json())
             .then((result) => {
                 if(result.status === true){
                     // console.log(result)
                     alert('Insert Successfully');
                     nearByList();
                 }else{
                     alert("Try Again..!!")
                 }
             })
            .catch((error) => console.error(error));
      }

      const editNearBy = ()=>{
        const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                ...updateNearBy
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(`https://api.padampura.com/NearBy_Update?MainID=${updateNearBy.NB_ID}`, requestOptions)
            .then((response) => response.json())
             .then((result) => {
                 if(result.status === true){
                     // console.log(result)
                     alert("Update Successfully")
                     nearByList();
                 }else{
                     alert("Try Again...!!")
                 }
             })
            .catch((error) => console.error(error));
      }

      const deleteNearBY = ()=>{
        const requestOptions = {
            method: "DELETE",
            redirect: "follow"
          };
          
          fetch(`https://api.padampura.com/NearBy_Delete?MainID=${updateNearBy.NB_ID}`, requestOptions)
           .then((response) => response.json())
            .then((result) => {
                if(result.status === true){
                    alert("Delete Successfully")
                    nearByList();
                }else{
                    alert("Try Again...!!")
                }
            })
            .catch((error) => console.error(error));
      }

     useEffect(()=>{
         nearByList();
     },[])

     const handleNearByCont = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, '');
        const limitedValue = numericValue.slice(0, 10);
        setPlaceCotactNumber(limitedValue);
    };

     const handleClear = ()=>{
        setPlaceName('');
        setPlaceCotactNumber('');
     }

     const sanitizeHtml = (html) => {
        if (html) {
          return html.replace(/<\/?p>/g, '');
        } else {
          return ''; 
        }
      };

    return (
        <>
            <div className='container-fluid p-0'>
                <div className='row g-0'>
                    <div className='col-2 side'>
                        <Sidebar />
                    </div>
                    <div className='col-10 side2'>
                        <Header />
                        <div className='scroll-box'>
                            <div className="container-fluid">
                                <div className='row d-flex justify-content-between mt-2'>
                                  <div className='col-4' style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "1.2em", }} >Near By</div>
                                  <div className='col-4'>
                                     <TextField
                                         label="Search by place name"
                                         value={searchQuery}
                                         onChange={(e) => setSearchQuery(e.target.value)}
                                         variant="outlined"
                                         size="small"
                                         fullWidth
                                         sx={{ mb: 0 }}
                                      />
                                  </div>
                                  <div onClick={handleShow} className='col-2 d-flex justify-content-center align-items-center p-1 rounded-1' style={{ backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>+ Add</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12 m-auto">
                                        <div className='card-list-box-sr card p-2 border-0'>
                                            <div className="table-responsive">
                                                <Paper sx={{ width: '100%' }}>
                                                    <TableContainer sx={{ mt: -1 }}>
                                                        <Table stickyHeader aria-label="sticky table" size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Place Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Place Description</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Mobile No.</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    loader?(
                                                                        <TableRow>
                                                                            <TableCell colSpan={3} align="center">
                                                                                <div style={{ fontFamily:"Poppins", fontSize:16 }} >Loading...</div>
                                                                                <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={loading}
                                                                                    style={{ height: '200px', width: '200px' }}
                                                                                >
                                                                                <Controls visible={false} buttons={['play', 'repeat', ]} />
                                                                            </Player>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ):filteredData.length === 0 ? (
                                                                        <TableRow>
                                                                            <TableCell colSpan={3} align="center">
                                                                             <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={lottiee}
                                                                                    style={{ height: '100px', width: '100px' }}
                                                                                >
                                                                                <Controls visible={false} buttons={['play', 'repeat', ]} />
                                                                             </Player>
                                                                             <div style={{ fontFamily:"Poppins", fontSize:16, color:'red' }} >Data Not Present...</div>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                    :(
                                                                        filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                                                            <TableRow key={index}>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}><div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.PlaceName) }} /></TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>
                                                                                   <div>
                                                                                       {showDescription[index] ? (
                                                                                           <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.PlaceDesc) }} />
                                                                                       ) : (
                                                                                           <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.PlaceDesc.slice(0, 80)) }} />
                                                                                       )}
                                                                                       {item.PlaceDesc.length > 80 && !showDescription[index] && (
                                                                                           <button className='border-0' onClick={() => handleShowMore(index)} style={{ color:'blue' }}>...Read More</button>
                                                                                       )}
                                                                                       {item.PlaceDesc.length > 80 && showDescription[index] && (
                                                                                           <button className='border-0' onClick={() => handleShowLess(index)} style={{ color:'blue' }}>Read Less...</button>
                                                                                       )}
                                                                                   </div>
                                                                                </TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}><div dangerouslySetInnerHTML={{ __html: sanitizeHtml('+91 '+item.PlaceCotactNumber) }} /></TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", }}>
                                                                                   <div className='d-flex justify-content-between'>
                                                                                     <FaEdit onClick={() => { handleShow2(); setupdateNearBy({...item}) }} style={{ cursor: "pointer", color:"#566573" }} />
                                                                                     <MdDelete onClick={()=> {setSmShow(true);setupdateNearBy({...item})}} style={{ cursor: "pointer", color: "#E74C3C" }} />
                                                                                   </div>
                                                                                </TableCell>
                                                                             </TableRow>
                                                                        ))
                                                                    )
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[8, 10, 20]}
                                                        component="div"
                                                        count={nearByData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                                <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                       <Modal.Title>Add NearBy</Modal.Title>
                                                    </Modal.Header>
                                                     <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                              <div className='col-2 ms-auto'>
                                                                <div onClick={() => { handleClose();insertNearBy();handleClear();setPlaceDesc('')}}  className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width:'100%', backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>Save</div>
                                                              </div>
                                                            </div>
                                                            <div className='row'>
                                                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Place Name</div>
                                                                <input className='sercc-inpt p-1' value={PlaceName} onChange={(e)=> setPlaceName(e.target.value)} placeholder="Place Name" autoFocus required style={{width:"100%"}} />
                                                            </div>
                                                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Contact Number</div>
                                                                <input className='sercc-inpt p-1' value={PlaceCotactNumber} maxLength={10} onChange={handleNearByCont} placeholder="Place Description" autoFocus required style={{width:"100%"}} />
                                                            </div>
                                                            {/* <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Contact Number</div>
                                                                <input type='url' className='sercc-inpt p-1' value={PlaceGoogleLocationLink} onChange={(e)=> setPlaceGoogleLocationLink(e.target.value)} placeholder="Map Link" autoFocus required style={{width:"100%"}} />
                                                            </div> */}
                                                            </div>
                                                           <div className='' style={{ width:"100%", height:"50vh", overflow:"scroll" }}>
                                                           <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Place Description</div>
                                                            <div className='row'>
                                                             <div className='col-lg-12 col-md-12 col-sm-12'>
                                                                  <CKEditor
                                                                      editor={ClassicEditor}
                                                                      data={PlaceDesc || ''}
                                                                      onChange={(event, editor) => {
                                                                          const data = editor.getData();
                                                                          setPlaceDesc(data);
                                                                      }}
                                                                      config={{
                                                                          enterMode: 'paragraph',
                                                                          shiftEnterMode: 'br',
                                                                          toolbar: {
                                                                              items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                                                                          },
                                                                          heading: {
                                                                              options: [
                                                                                  { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                                                                  { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                                                                  { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                                                                  { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                                                                  { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                                                                  { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                                                                  { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                                                              ]
                                                                          }
                                                                      }}
                                                                  />
                                                              </div>
                                                            </div>
                                                           </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                                <Modal show={show2} onHide={handleClose2} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                       <Modal.Title>Edit Near By</Modal.Title>
                                                    </Modal.Header>
                                                     <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                              <div className='col-2 ms-auto'>
                                                                <div onClick={()=> {handleClose2();editNearBy()}} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width:'100%', backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>Update</div>
                                                              </div>
                                                            </div>
                                                            <div className='row'>
                                                              <div className='col-lg-6 col-md-6 col-sm-12'>
                                                                  <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Place Name</div>
                                                                  <input className='sercc-inpt p-1' name='PlaceName' value={updateNearBy.PlaceName} onChange={handleChangeUpdtNaerBY} placeholder="Place Name" autoFocus required style={{width:"100%"}} />
                                                              </div>
                                                              <div className='col-lg-6 col-md-6 col-sm-12'>
                                                                  <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Contact Number</div>
                                                                  <input className='sercc-inpt p-1' value={updateNearBy.PlaceCotactNumber} onChange={handleChangeUpdtNaerBY} name='PlaceCotactNumber' type="tel" pattern="[0-9]*" maxLength={10} placeholder="Place ContactNumber" autoFocus required style={{width:"100%"}} />
                                                              </div>
                                                            </div>
                                                            <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Place Description</div>
                                                            <div className='' style={{ width:"100%", height:"50vh", overflow:"scroll" }} >
                                                             <div className='row'>
                                                               <div className='col-lg-12 col-md-12 col-sm-12'>
                                                                   <CKEditor
                                                                       editor={ClassicEditor}
                                                                       data={updateNearBy.PlaceDesc || ''}
                                                                       onChange={(event, editor) => {
                                                                       const data = editor.getData();
                                                                       setupdateNearBy({
                                                                           ...updateNearBy,
                                                                           PlaceDesc: data
                                                                       });
                                                                       }}
                                                                       config={{
                                                                           enterMode: 'paragraph',
                                                                           shiftEnterMode: 'br',
                                                                           toolbar: {
                                                                               items: ['heading', '|', 'bold', 'italic', 'alignment', '|', 'undo', 'redo']
                                                                           },
                                                                           heading: {
                                                                               options: [
                                                                                   { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                                                                                   { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                                                                                   { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                                                                                   { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                                                                                   { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                                                                                   { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                                                                                   { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                                                                               ]
                                                                           }
                                                                       }}
                                                                   />
                                                               </div>
                                                             </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        <FiAlertTriangle style={{ color: "orangered" }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center align-items-center" style={{ fontFamily: 'Poppins', fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>Are you sure want to Delete ??</div>
                    <div className='d-flex justify-content-between mt-3'>
                        <div onClick={()=> {setSmShow(false);deleteNearBY()}} className='d-flex justify-content-center align-items-center p-1 rounded-1 me-2' style={{ width: '100%', backgroundColor: "#239B56", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Yes</div>
                        <div onClick={()=> setSmShow(false)} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#E74C3C", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>No</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
